// extracted by mini-css-extract-plugin
export default {"main":"_346046d891 _415e0dce5a _6c467cfc9a _2878162ae8","title":"beac45829c"};